import { ReactElement } from 'react'
import Loader from 'src/components/shared/ui/Loader/Loader'
import useStyles from './useStyles'

function LoadingIndicator(): ReactElement {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <Loader />
    </div>
  )
}

export default LoadingIndicator
